import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

import { computed, ref } from "vue";
import { ENABLED_FEATURES, getIcon } from "@/util";
import {
  appStore,
  artifactSaveStore,
  cyStore,
  layoutStore,
  permissionStore,
} from "@/hooks";
import { IconButton } from "@/components/common";


/**
 * Displays action buttons for the artifact tree graph.
 */
const __default__ = {
  name: "GraphFab",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const open = ref(false);
const fabPos = ref([18, 18]);
const draggingFab = ref(false);

const isTreeMode = computed(
  () => !appStore.isLoading && layoutStore.isTreeMode
);
const drawMode = computed(() => appStore.popups.drawTrace);

const displayActions = computed(() =>
  permissionStore.isAllowed("project.edit_data")
);
const displayGenerateActions = computed(() =>
  permissionStore.isAllowed("project.generate")
);

/**
 * Handles moving the fab tro another location.
 * @param ev - The move event.
 */
function handleMoveFab(ev: {
  isFirst?: boolean;
  isFinal?: boolean;
  delta: { x: number; y: number };
}) {
  draggingFab.value = ev.isFirst !== true && ev.isFinal !== true;

  fabPos.value = [fabPos.value[0] + ev.delta.x, fabPos.value[1] - ev.delta.y];
}

return (_ctx: any,_cache: any) => {
  const _component_q_fab_action = _resolveComponent("q-fab-action")!
  const _component_q_fab = _resolveComponent("q-fab")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _directive_touch_pan = _resolveDirective("touch-pan")!

  return (displayActions.value)
    ? (_openBlock(), _createBlock(_component_q_page_sticky, {
        key: 0,
        offset: fabPos.value,
        class: "artifact-fab",
        position: "bottom-left"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_q_fab, {
            modelValue: open.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((open).value = $event)),
            "active-icon": _unref(getIcon)('cancel'),
            color: drawMode.value ? 'secondary' : 'gradient',
            disable: draggingFab.value,
            icon: drawMode.value ? _unref(getIcon)('trace') : _unref(getIcon)('graph-add'),
            class: "bg-neutral",
            "data-cy": "button-fab-toggle",
            direction: "up",
            "vertical-actions-align": "left"
          }, {
            default: _withCtx(() => [
              (displayGenerateActions.value)
                ? (_openBlock(), _createBlock(_component_q_fab_action, {
                    key: 0,
                    icon: _unref(getIcon)('generate-traces'),
                    class: "bg-neutral",
                    color: "gradient",
                    "data-cy": "button-fab-generate-trace",
                    label: "Generate Trace Links",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).openDetailsPanel('generateTrace')))
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (displayGenerateActions.value)
                ? (_openBlock(), _createBlock(_component_q_fab_action, {
                    key: 1,
                    icon: _unref(getIcon)('generate-artifacts'),
                    class: "bg-neutral",
                    color: "gradient",
                    "data-cy": "button-fab-generate-artifact",
                    label: "Generate Artifacts",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(appStore).openDetailsPanel('generateArtifact')))
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (displayGenerateActions.value && _unref(ENABLED_FEATURES).GENERATE_SUMMARIES)
                ? (_openBlock(), _createBlock(_component_q_fab_action, {
                    key: 2,
                    icon: _unref(getIcon)('generate-summaries'),
                    class: "bg-neutral",
                    color: "gradient",
                    "data-cy": "button-fab-summarize-artifact",
                    label: "Summarize Artifacts",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(appStore).openDetailsPanel('summarizeArtifact')))
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (isTreeMode.value)
                ? (_openBlock(), _createBlock(_component_q_fab_action, {
                    key: 3,
                    icon: drawMode.value ? _unref(getIcon)('cancel') : _unref(getIcon)('trace'),
                    label: drawMode.value ? 'Cancel Draw Mode' : 'Draw Trace Link',
                    class: "bg-neutral",
                    "data-cy": "button-fab-draw-trace",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(cyStore).drawMode('toggle')))
                  }, null, 8, ["icon", "label"]))
                : _createCommentVNode("", true),
              (isTreeMode.value)
                ? (_openBlock(), _createBlock(_component_q_fab_action, {
                    key: 4,
                    icon: _unref(getIcon)('create-trace'),
                    class: "bg-neutral",
                    "data-cy": "button-fab-create-trace",
                    label: "Create Trace Link",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(appStore).openDetailsPanel('saveTrace')))
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (isTreeMode.value)
                ? (_openBlock(), _createBlock(_component_q_fab_action, {
                    key: 5,
                    icon: _unref(getIcon)('create-artifact'),
                    class: "bg-neutral",
                    "data-cy": "button-fab-create-artifact",
                    label: "Create Artifact",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(artifactSaveStore).openPanel({ isNewArtifact: true })))
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "active-icon", "color", "disable", "icon"])), [
            [
              _directive_touch_pan,
              handleMoveFab,
              void 0,
              {
                prevent: true,
                mouse: true
              }
            ]
          ]),
          (drawMode.value)
            ? (_openBlock(), _createBlock(_unref(IconButton), {
                key: 0,
                class: "q-ml-sm",
                icon: "cancel",
                tooltip: "Cancel draw mode",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(cyStore).drawMode('disable')))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["offset"]))
    : _createCommentVNode("", true)
}
}

})